import { render, staticRenderFns } from "./tkdevreraporu.vue?vue&type=template&id=767c1156&"
import script from "./tkdevreraporu.vue?vue&type=script&lang=js&"
export * from "./tkdevreraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports